import { createSvgComponent } from "../../icon/createSvgComponent";
import ChatbubbleTypingFill from "@core/__generated__/icon/figma/chatbubble-typing-fill.svg";
export default createSvgComponent(ChatbubbleTypingFill);